document.addEventListener("DOMContentLoaded", function() {
  const tipsBlockBtn = document.querySelector(".tips-block__btn-text");
  const tipsBlockWrapper = document.querySelector(".tips-block");

  tipsBlockBtn &&
    tipsBlockBtn.addEventListener("click", function(event) {
      tipsBlockWrapper.classList.toggle("tips-block--show");
    });
});
